import {
    debug, form, formHelpers, Formsy, i18n, inject, mui, observable, observer, pr, React, RouteComponentProps, theme, ui
} from "aaa";
import * as _ from "lodash";
import { Attachments } from "models/Attachment";
import { User } from "models/User";
import Dropzone from "react-dropzone";
import { FormsyCheckboxWithValidation } from "./util/FormsyCheckboxWithValidation";

type IProps = i18n.InjectedIntlProps & {
    user: User,
    attachments: Attachments,
    isSummary?: boolean
    invalidSubmit: boolean;
};

@i18n.injectIntl
@inject("user")
@observer
export class DocumentsContent extends React.Component<IProps, {}> {

    onFileDrop = async (accepted: any, rejected: any) => {
        if (rejected && rejected.length > 0) {
            ui.showMessageBox({
                title: ui.__("summary.attachmentInvalid.title"),
                message: ui.__("summary.attachmentInvalid.message"),
            });
            return;
        }

        if (!accepted || accepted.length <= 0) {
            return;
        }

        const file: File = accepted[0];

        const FILESIZE_LIMIT = 10 * 1024 * 1024;
        if (file.size > FILESIZE_LIMIT) {
            ui.showMessageBox({
                title: ui.__("summary.attachmentInvalid.title"),
                message: ui.__("summary.attachments.tooBig"),
            });
            return;
        }

        if (this.props.attachments.attachmentExists(file)) {
            ui.showMessageBox({
                title: ui.__("summary.attachmentExists.title"),
                message: ui.__("summary.attachmentExists.message"),
            });
            return;
        }

        this.props.attachments.addFile(file);

    }

    renderAttachments() {
        const WIDTH = 140;
        const HEIGHT = 80;

        const UPLOAD_ALLOWED_DOC_MIME_TYPES = [
            "image/jpeg",
            // "image/png",
            // "image/tiff",
            "application/pdf",
            // "application/msword",
            // "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        ];

        const MIME_TYPES = UPLOAD_ALLOWED_DOC_MIME_TYPES.join(", ");

        const baseStyle = {
            position: "relative",
            width: WIDTH,
            height: HEIGHT,
            background: theme.LIGHT_BLUE,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
            padding: theme.MARGIN,
            marginBottom: theme.MARGIN,
            marginRight: theme.MARGIN,
            borderRadius: 8
        } as any;

        let showDropZone = !this.props.isSummary;
        const attachments = this.props.attachments.attachments.map(entry => {
            if (this.props.attachments.uploading) {
                showDropZone = false;

                // Entry is currently uploading
                return (
                    <div
                        key={entry.file.name + entry.file.size + entry.file.lastModifiedDate}
                        style={baseStyle}
                    >
                        <mui.RefreshIndicator
                            size={50}
                            left={0}
                            top={0}
                            status={"loading"}
                            style={{
                                display: "inline-block",
                                position: "relative"
                            }}
                        />
                    </div>
                );
            } else {
                let content: any;
                if (_.startsWith(entry.file.type, "image")) {
                    content = (
                        <img
                            style={{ maxWidth: "100%", maxHeight: "100%" }}
                            src={(entry.file as any).preview}
                        />
                    );
                } else {
                    content = entry.file.name;
                }

                // Entry is thumbnail
                return (
                    <div
                        key={entry.file.name}
                        style={baseStyle}
                    >
                        {content}
                        {!this.props.isSummary && !this.props.attachments.deleting &&
                            <mui.IconButton
                                style={{ position: "absolute", top: -4, right: -4 }}
                                iconStyle={{ color: theme.SPARDA_BLUE, opacity: 0.5 }}
                                onClick={async () => {
                                    try {
                                        await this.props.attachments.removeAttachment(entry);
                                    } catch (error) {
                                        ui.showGenericError(error.statusCode);
                                    }
                                }}
                            >
                                <pr.IconTrash />
                            </mui.IconButton>}
                    </div>
                );
            }
        });

        return (
            <div>
                {/* <pr.Title>{ui.__("summary.attachments")}</pr.Title> */}
                <ul style={{ paddingLeft: theme.MARGIN }}>
                    <li>{ui.__("summary.attachments.personalId")}</li>
                    <li>{ui.__("summary.attachments.payslips")}</li>
                    {this.props.user.income.rent.value > 0 ? (
                        <li>
                            <a
                                href="https://www.sparda-hessen.de/internetauftritt/downloads/formularcenter/aufstellung-mieteinnahmen.pdf"
                                target="_blank"
                            >
                                {ui.__("summary.attachments.rentUpload")}
                            </a>
                        </li>
                    ) : null}
                </ul>

                <pr.HFlex style={{ flexWrap: "wrap" }}>
                    {attachments}
                    {showDropZone &&
                        <Dropzone
                            onDrop={this.onFileDrop}
                            multiple={false}
                            accept={MIME_TYPES}
                            style={{
                                ...baseStyle,
                                cursor: "pointer",
                            }}
                        >
                            {ui.__("summary.attachments.dragOrChoose")}
                        </Dropzone>
                    }
                </pr.HFlex>
            </div>
        );
    }


    render() {
        return (
            <div>
                {this.renderAttachments()}
                <FormsyCheckboxWithValidation
                    style={{ marginTop: theme.MARGIN }}
                    labelStyle={{
                        maxWidth: Math.min(ui.windowWidth, theme.MAX_APP_WIDTH) * 0.8 // Fix for IE overflowing
                    }}
                    validations="isTrue"
                    submitted={this.props.invalidSubmit}
                    validationError={ui.__("error.requiredField")}
                    name="ownerOfObject"
                    label={ui.__("summary.ownerOfObject")}
                    defaultChecked={this.props.user.ownerOfObject
                    }
                />

                <form.FormsyText
                    name="objectAddress"
                    required={true}
                    validations={"minLength:1"}
                    floatingLabelText={ui.__("address")}
                    fullWidth={true}
                    validationError={ui.__("error.requiredField")}
                    value={this.props.user.objectAddress ? this.props.user.objectAddress : this.props.user.address}
                />

                <form.FormsyText
                    name="objectZipAndResidence"
                    required={true}
                    validations={"minLength:1"}
                    floatingLabelText={ui.__("zipCodeAndResidence")}
                    fullWidth={true}
                    validationError={ui.__("error.requiredField")}
                    value={this.props.user.objectZipAndResidence ? this.props.user.objectZipAndResidence : this.props.user.zipCode + ", " + this.props.user.residence}
                />

                <form.FormsyText
                    name="objectDistrictCourt"
                    required={true}
                    validations={"minLength:1"}
                    floatingLabelText={ui.__("objectDistrictCourt")}
                    fullWidth={true}
                    validationError={ui.__("error.requiredField")}
                    value={this.props.user.objectDistrictCourt}
                />

                <form.FormsyText
                    name="objectRegister"
                    required={true}
                    validations={"minLength:1"}
                    floatingLabelText={ui.__("objectRegister")}
                    fullWidth={true}
                    validationError={ui.__("error.requiredField")}
                    value={this.props.user.objectRegister}
                />

                <form.FormsyText
                    name="objectSheetNumber"
                    required={true}
                    validations={"minLength:1"}
                    floatingLabelText={ui.__("objectSheetNumber")}
                    fullWidth={true}
                    validationError={ui.__("error.requiredField")}
                    value={this.props.user.objectSheetNumber}
                />
            </div>
        );
    }
}


@i18n.injectIntl
@inject("user", "attachments")
@observer
export class DocumentsForm extends React.Component<RouteComponentProps<{}> & IProps & { onSubmit: (keysSubmittedFields: string[]) => void }, {}> {

    @observable
    formIsValid = true;

    @observable
    invalidSubmit = false;

    private formRef: any;

    static parseInput(user: User, fields: any) {
        user.ownerOfObject = fields.ownerOfObject;
        user.objectAddress = fields.objectAddress;
        user.objectZipAndResidence = fields.objectZipAndResidence;
        user.objectDistrictCourt = fields.objectDistrictCourt;
        user.objectRegister = fields.objectRegister;
        user.objectSheetNumber = fields.objectSheetNumber;
    }

    componentDidMount() {
        window.scrollTo(0, 0);

        // SUCCESS-REDIRECT: user has already fully submitted previously, hard redirect to /loan
        if (this.props.user.successfullySubmitted === true) {
            window.location.replace(window.location.origin + window.location.pathname); // we wont include hash - root page only.
        }
    }

    onSubmit = async (fields: any, resetForm: any, invalidateForm: any) => {
        const user = this.props.user;
        DocumentsForm.parseInput(user, fields);
        debug.log("### Documents user", user);

        if (this.props.attachments.attachments.length === 0) {
            ui.showMessageBox({ title: ui.__("summary.attachments"), message: ui.__("summary.attachmentsMising") });
        } else {
            try {
                await this.props.attachments.uploadAll();

                const submittedFields = _.compact(_.map(fields as _.Dictionary<any>, (value, key) => {
                    return _.isNil(value) ? null : key;
                }));

                this.props.onSubmit(submittedFields);

                this.props.history.push("/summary");
            } catch (error) {
                ui.showMessageBox({
                    title: ui.__("error"),
                    message: ui.__("error.upload") + ", " + error.statusCode,
                });
            }
        }
    }

    render() {
        return (
            <pr.FormContainer>
                <Formsy.Form
                    onInvalidSubmit={(fields: any, reset: any, invalidate: any) => {
                        this.invalidSubmit = true;
                        formHelpers.invalidateRequiredFields(this.formRef, invalidate);
                    }
                    }
                    onValidSubmit={(
                        fields: any,
                        resetForm: any,
                        invalidateForm: any
                    ) => {
                        this.invalidSubmit = false;
                        this.onSubmit(fields, resetForm, invalidateForm);
                    }
                    }
                    onValid={() => { this.formIsValid = true; }}
                    onInvalid={() => { this.formIsValid = false; }}
                    noValidate
                    ref={(c: any) => this.formRef = c}
                >
                    <DocumentsContent user={this.props.user} attachments={this.props.attachments} invalidSubmit={this.invalidSubmit} />
                    {formHelpers.renderActionButton(ui.__("uploadNow"), this.props.attachments.uploading)}
                </Formsy.Form>
            </pr.FormContainer >
        );
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/DocumentsForm.tsx